import { SHOW_INIT_DASHBOARD_FILTERS_KEY } from '../../utils/constants';

export const scroll = (c: any, a: any, b: any, i: any) => {
  i++;
  if (i > 30) return;
  c.scrollTop = a + ((b - a) / 75) * i;
  setTimeout(function () {
    scroll(c, a, b, i);
  }, 20);
};
export const saveDashboardFiltersUserChoice = (event: any) => {
  if (event?.target.checked) {
    localStorage.setItem(SHOW_INIT_DASHBOARD_FILTERS_KEY, 'false');
  } else {
    localStorage.removeItem(SHOW_INIT_DASHBOARD_FILTERS_KEY);
  }
};

export const smoothScroll = (name: string) => {
  let target: any = document.getElementById(name);
  let scrollContainer = target;
  do {
    //find scroll container
    scrollContainer = scrollContainer.parentNode;
    if (!scrollContainer) return;
    scrollContainer.scrollTop += 1;
  } while (scrollContainer.scrollTop == 0);

  let targetY = 150;
  do {
    //find the top of target relatively to the container
    if (target == scrollContainer) break;
    targetY += target.offsetTop;
  } while ((target = target.offsetParent));
  // start scrolling
  scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
};
